import Cookie from 'js-cookie';

const FFS_ID_KEY = 'atlassian.account.ffs.id';

// TODO refactor to read from redux store https://hello.jira.atlassian.cloud/browse/KIRBY-7514
export function getFfsId(): string | undefined {
  const ffsId = Cookie.get(FFS_ID_KEY);
  return ffsId && ffsId.replace(/(^")|("$)/g, '');
}
